import React, {useCallback, useContext, useEffect} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import {useMenu} from '../../../hooks/useMenu';
import ZeroCalibration from './zero-calibration';
import CommandsContext from '../../../context/commandsContext';

function ZeroCompleteFinished({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<ZeroCalibration />);
  }, []);

  const onRight = useCallback(() => {
    onComponent(<ZeroCalibration />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft, onRight});
  }, [onLeft, onRight]);

  return (
    <BodyContentView
      title="Zero Complete"
      left="Options"
      right="Finished"
      caption="The zero calibration has been successfully completed and the zero value has been updated."
    />
  );
}

export default ZeroCompleteFinished;
